import { useEffect, useState, useCallback } from 'react';

// Vérification de l'environnement localhost
// const isLocalhost = () => {
//   return window.location.hostname === 'localhost' || 
//          window.location.hostname === '127.0.0.1' ||
//          window.location.hostname.includes('192.168.');
// };

const isLocalhost = () => {
  return true
}
// Fonction de log conditionnelle
const conditionalLog = (message, style) => {
  if (isLocalhost()) {
    style ? console.log(message, style) : console.log(message);
  }
};

const conditionalError = (message) => {
  if (isLocalhost()) {
    console.error(message);
  }
};

// Gestionnaire des événements pour éviter les doublons
const eventTracker = {
  loggedEvents: new Set(),
  trackEvent(eventId, timeout = 1000) {
    if (this.loggedEvents.has(eventId)) return false;
    this.loggedEvents.add(eventId);
    setTimeout(() => this.loggedEvents.delete(eventId), timeout);
    return true;
  }
};

// Intercepteur des requêtes fetch
const createFetchInterceptor = () => {
  return () => {
    // Evite que l'intercepteur se duplique.
    if (window.__fetchInterceptorInitialized) return;
    window.__fetchInterceptorInitialized = true;

    conditionalLog(
      "%c Initialisation de l'intercepteur Fetch",
      "color: #4B5563; font-weight: bold"
    );

    const originalFetch = window.fetch;

    window.fetch = async function (url, options = {}) {
      const requestUrl = typeof url === "string" ? url : url.url;
      const path = extractPathFromUrl(requestUrl);

      try {
        const response = await originalFetch.apply(this, arguments);

        if (isLocalhost()) {
          const originalJson = response.json.bind(response);
          let alreadyLogged = false;

          response.json = async () => {
            const data = await originalJson();

            if (!alreadyLogged) {
              alreadyLogged = true;
              try {
                const routeInfo = extractRouteInfo(data);
                if (routeInfo) {
                  const routeData = formatRouteData(routeInfo, path);
                  logRouteInfo(routeData);
                }
              } catch (e) {} // Ignore les erreurs de parsing JSON
            }

            return data;
          };
        }

        return response;
      } catch (error) {
        throw error;
      }
    };
  };
};

// Fonction d'extraction du chemin d'une URL
const extractPathFromUrl = (url) => {
  try {
    if (url.startsWith('/') || !url.includes('://')) {
      const baseUrl = window.location.origin;
      const urlObj = new URL(url.startsWith('/') ? baseUrl + url : baseUrl + '/' + url);
      return urlObj.pathname;
    } else {
      return new URL(url).pathname;
    }
  } catch (e) {
    return url;
  }
};

// Fonction de nettoyage HTML
const cleanHtml = str => str ? str.replace(/<[^>]*>/g, '') : str;

// Extraction des informations de route
const extractRouteInfo = (data) => {
  if (data?.route) return data.route;
  if (data?.phpdebugbar?.data?.route) return data.phpdebugbar.data.route;
  if (data?.id && data?.data?.route) return data.data.route;
  return null;
};

// Formatage des données de route
const formatRouteData = (routeInfo, path) => {
  const routeData = {
    method: 'N/A',
    path: path,
    fullPath: path,
    controller: 'N/A',
    action: 'N/A',
    namespace: null,
    middleware: routeInfo.middleware || 'N/A',
    routeName: routeInfo.as || 'N/A',
    prefix: routeInfo.prefix || null,
    file: cleanHtml(routeInfo.file || '')
  };
  
  // Extraction de l'URI
  if (routeInfo.uri) {
    const uriParts = routeInfo.uri.split(' ');
    if (uriParts.length >= 2) {
      routeData.method = uriParts[0];
      routeData.path = uriParts[1].startsWith('/') ? uriParts[1] : '/' + uriParts[1];
    } else {
      routeData.path = routeInfo.uri;
    }
  }
  
  // Construction du chemin complet
  if (routeData.prefix) {
    const prefix = routeData.prefix.startsWith('/') ? routeData.prefix : '/' + routeData.prefix;
    
    if (!routeData.path.startsWith(prefix)) {
      routeData.fullPath = `${prefix}${routeData.path.startsWith('/') ? routeData.path : '/' + routeData.path}`;
    } else {
      routeData.fullPath = routeData.path;
    }
    
    routeData.fullPath = routeData.fullPath.replace(/\/+/g, '/');
  } else {
    routeData.fullPath = routeData.path;
  }
  
  // Extraction du contrôleur
  if (routeInfo.controller) {
    const cleanController = cleanHtml(routeInfo.controller);
    const controllerParts = cleanController.split('@');
    
    if (controllerParts.length > 0) {
      const namespaceParts = controllerParts[0].split('\\');
      routeData.controller = namespaceParts.pop() || controllerParts[0];
      
      const apiIndex = namespaceParts.findIndex(part => part === 'Api');
      if (apiIndex !== -1) {
        routeData.namespace = 'Api';
      }
      
      routeData.action = controllerParts[1]?.replace(/<.*/, '') || 'N/A';
    }
  }
  
  // Format du middleware
  routeData.middleware = Array.isArray(routeData.middleware) 
    ? routeData.middleware.join(', ') 
    : routeData.middleware;
    
  return routeData;
};

// Affichage des informations de route
const logRouteInfo = (routeData) => {
  if (!isLocalhost()) return;
  
  conditionalLog('✨ INFOS ROUTE');
  conditionalLog(`• Méthode:     ${routeData.method} ${routeData.fullPath}`);
  if (routeData.namespace) {
    conditionalLog(`• Namespace:   ${routeData.namespace}`);
  }
  conditionalLog(`• Contrôleur:  ${routeData.controller}@${routeData.action}`);
  conditionalLog(`• Middleware:  ${routeData.middleware}`);
  if (routeData.routeName !== 'N/A') {
    conditionalLog(`• Nom route:   ${routeData.routeName}`);
  }
  if (routeData.file) {
    conditionalLog(`• Fichier:     ${routeData.file}`);
  }
  conditionalLog(''); // Ligne vide pour séparer
};

// Récupération des logs serveur
export const fetchServerLogs = async () => {
  if (!isLocalhost()) return;
  
  try {
    const response = await fetch('/api/server-logs');
    const data = await response.json();
    
    if (data.logs && Array.isArray(data.logs)) {
      conditionalLog('%c LOGS SERVEUR', 'color: #D97706; font-weight: bold');
      data.logs.forEach(log => conditionalLog(log));
    } else if (data.error) {
      conditionalError('Erreur de récupération des logs:', data.error);
    }
  } catch (error) {
    conditionalError('Impossible de récupérer les logs serveur:', error);
  }
};

// Hook principal useLoading
export function useLoading() {
  const [isLoading, setIsLoading] = useState(false);
  const [validationState, setValidationState] = useState({
    isValidating: false,
    currentValidation: null,
    lastValidationResult: null
  });
  
  // Initialisation de l'intercepteur
  const setupInterceptor = createFetchInterceptor();
  
  // Gestionnaires d'événements Inertia
  const handleInertiaStart = useCallback((event) => {
    const visit = event.detail?.visit;
    if (visit?.url && typeof visit.url === 'string' && !visit.url.includes('/api/')) {
      conditionalLog(' Requête démarrée -', visit.url);
    }
    setIsLoading(true);
  }, []);
  
  const handleInertiaFinish = useCallback((event) => {
    const visit = event.detail?.visit;
    const page = event.detail?.page;
    
    if (visit?.url && typeof visit.url === 'string' && !visit.url.includes('/api/')) {
      conditionalLog(' Requête terminée -', visit.url);
    }
    
    if (page?.component) {
      conditionalLog(' Page chargée:', page.component);
    }
    
    setIsLoading(false);
  }, []);
  
  const handleInertiaError = useCallback((event) => {
    conditionalError(' Erreur lors de la requête');
    const errors = event.detail?.errors;
    if (errors) {
      conditionalError(' Erreurs de validation:', errors);
    }
    setIsLoading(false);
  }, []);
  
  // Gestionnaires d'événements de validation
  const handleValidationStart = useCallback((event) => {
    if (!isLocalhost()) {
      setValidationState(prev => ({
        ...prev,
        isValidating: true,
        currentValidation: event.detail
      }));
      return;
    }
    
    const eventId = `validation-start-${event.detail.questionId}-${event.detail.attemptNumber}`;
    
    if (!eventTracker.trackEvent(eventId)) return;
    
    conditionalLog(`%c Validation démarrée - Question ${event.detail.questionId}`, 'color: #8B5CF6;');
    
    setValidationState(prev => ({
      ...prev,
      isValidating: true,
      currentValidation: event.detail
    }));
  }, []);
  
  const handleValidationComplete = useCallback((event) => {
    if (!isLocalhost()) {
      setValidationState(prev => ({
        ...prev,
        isValidating: false,
        lastValidationResult: event.detail,
        currentValidation: null
      }));
      setIsLoading(false);
      return;
    }
    
    const eventId = `validation-complete-${event.detail.questionId}-${event.detail.timeTaken}`;
    
    if (!eventTracker.trackEvent(eventId)) return;
    
    conditionalLog(`%c Validation terminée - Question ${event.detail.questionId} - Résultat: ${event.detail.isCorrect ? 'Correct' : 'Incorrect'}`, 'color: #10B981');
    
    setValidationState(prev => ({
      ...prev,
      isValidating: false,
      lastValidationResult: event.detail,
      currentValidation: null
    }));
    
    setIsLoading(false);
  }, []);
  
  const handleValidationError = useCallback((event) => {
    if (!isLocalhost()) {
      setValidationState(prev => ({
        ...prev,
        isValidating: false,
        currentValidation: null
      }));
      setIsLoading(false);
      return;
    }
    
    const eventId = `validation-error-${event.detail.questionId}`;
    
    if (!eventTracker.trackEvent(eventId)) return;
    
    conditionalError(` Erreur de validation - Question ${event.detail.questionId}`, 'color: #EF4444');
    
    setValidationState(prev => ({
      ...prev,
      isValidating: false,
      currentValidation: null
    }));
    
    setIsLoading(false);
  }, []);
  
  // Effet pour la synchronisation isLoading/validation
  useEffect(() => {
    if (validationState.isValidating && isLocalhost()) {
      conditionalLog('%c Activation du loader global depuis useLoading', 'color: #FF5733; font-weight: bold');
    }
  }, [validationState.isValidating]);
  
  // Effet pour la configuration des écouteurs d'événements
  useEffect(() => {
    setupInterceptor();
    
    // Ajout des écouteurs d'événements
    document.addEventListener('inertia:start', handleInertiaStart);
    document.addEventListener('inertia:finish', handleInertiaFinish);
    document.addEventListener('inertia:error', handleInertiaError);
    document.addEventListener('validation:start', handleValidationStart);
    document.addEventListener('validation:complete', handleValidationComplete);
    document.addEventListener('validation:error', handleValidationError);
    
    // Nettoyage des écouteurs d'événements
    return () => {
      document.removeEventListener('inertia:start', handleInertiaStart);
      document.removeEventListener('inertia:finish', handleInertiaFinish);
      document.removeEventListener('inertia:error', handleInertiaError);
      document.removeEventListener('validation:start', handleValidationStart);
      document.removeEventListener('validation:complete', handleValidationComplete);
      document.removeEventListener('validation:error', handleValidationError);
    };
  }, []);
  
  return {
    isLoading,
    validation: validationState
  };
}